import { Component, OnInit } from '@angular/core';
import { ModalBackdropComponent } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { Project } from 'src/app/models/project';
import { AddProjectControlService } from 'src/app/services/add-project-control.service';
import { AnnotationService } from 'src/app/services/annotation.service';
import { AreaService } from 'src/app/services/area.service';
import { CoordinatePointsService } from 'src/app/services/coordinate-points.service';
import { CreateProjectService } from 'src/app/services/create-project.service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import { ProjectService } from 'src/app/services/project.service';
import { TabsService } from 'src/app/services/tabsService';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { ModalConfirmationMessageComponent } from 'src/app/utils/modals/modal-confirmation-message/modal-confirmation-message.component';
import { CreateProjectComponent } from '../../popup/create-project/create-project.component';
import { GlobalSelectionControlService } from '../services/global-selection-control.service';
import { MapService } from 'src/app/services/map.service';


@Component({
    selector: 'app-projects-control',
    templateUrl: './projects-control.component.html',
    styleUrls: ['./projects-control.component.scss'],
    standalone: false
  })

  export class ProjectsControlComponent implements OnInit {
    projectController: ProjectService;

    active:boolean = false;

    constructor(
      public projController : ProjectService,
      private projectDetailController: AddProjectControlService,
      private modelConfirmationMessage: ModalConfirmationService,
      private createProjectModal: CreateProjectService,
      private pointsController : PointsService,
      private errorModal : ModalControlService,
      private areaService : AreaService,
      private modalService : ModalControlService,
      private toolsService : ToolsControlService,
      private mapService: MapService,
      private tabsService : TabsService,
      public coordinatePointsService: CoordinatePointsService,
      ) {
        this.projectController = projController;
        this.projectController.activeProject = new Project();
    }

    ngOnInit(): void {
      this.projectController.getAllProjects();
    }

    projectsTrigger():void {
      this.active = !this.active;
    }

    editProjectDetailsTrigger(): void {
      if(this.projectController.selectedProject.id == this.projectController.activeProject.id && this.projController.activeProject.editable){
        this.projectDetailController.active = !this.projectDetailController.active;
        this.projectDetailController.selectedProject = this.projController.activeProject;
        this.toolsService.navigationOnTop = true;
      }
    }

    deleteProjectTrigger(): void {
      if(this.projectController.selectedProject.id == this.projectController.activeProject.id && this.projController.selectedProject.editable){
        this.errorModal.showMesssageModal("Warning","The active project cannot be deleted.");
      } else if (this.projectController.selectedProject && this.projController.selectedProject.editable){
       this.modelConfirmationMessage.showMesssageConfirmationModal("Delete Project", "Do you want to delete the project with the name '" + this.projectController.selectedProject.name + "'?", 'Yes', 'No',  this.boundedDeleteSelectedProject);
      }
    }

    RemoveProjectFromObjectArray(id: number) : void {
      this.projectController.projects.forEach((value,index)=>{
          if(value.id==id) this.projectController.projects.splice(index,1);
      });
  }

  boundedDeleteSelectedProject = this.deleteSelectedProject.bind(this);

  deleteSelectedProject() : void {
    this.projController.deleteProject(this.projectController.selectedProject.id).subscribe(
      (data) => {
        if (data){
          this.RemoveProjectFromObjectArray(this.projectController.selectedProject.id);
          this.projectController.selectedProject = undefined;
          this.modalService.showMesssageModal(
            'Delete',
            'The Project was deleted successfully.'
          );
        }else {
          this.errorModal.showMesssageModal("Error","Error deleting project.");
        }

      },
      (error) => {
        this.errorModal.showMesssageModal("Error","Error deleting project.");
      }
    );
  }

  addProjectTrigger():void{
    //Create project default values
    let emptyProject: Project = new Project();
    emptyProject.name= "New Project";
    emptyProject.description = "Description";
    emptyProject.configurationID = 1;
    this.createProjectModal.showModal(emptyProject, false, this.projController.projects);
  }

  editProjectTrigger():void{
    if (this.projectController.selectedProject && this.projectController.selectedProject.editable){
      // default value, just to pass the edit form validation.
      this.projectController.selectedProject.configurationID = 1;
      this.createProjectModal.showModal(this.projectController.selectedProject, true, this.projController.projects);
    }
  }

  activateProject(project : Project){
    const extent = this.mapService.getCurrentExtent();
    this.projController.activateProject(project).subscribe(
      (data) => {
        if (data){

          this.areaService.fetchAllAreasAndSetDefault(true, () => {

            this.projectController.getAllProjects();
            this.projectController.activeProject = project;
            
            this.pointsController.deleteNavaidsFromMap();
            this.pointsController.fetchAndAddPartialNavaids(extent);

            this.pointsController.deleteCoordinatePointsFromMap();
            this.pointsController.fetchAndAddPartialCoordinatePoints(extent);

            this.pointsController.deleteProceduresFromMap();
            this.pointsController.fetchAndAddPartialProcedures(extent);
            
            this.pointsController.deleteAirSpaceBoundariesFromMap();
            this.pointsController.fetchAndAddPartialAirSpaceBoundaries(extent);

            this.pointsController.fetchAndAddPartialTrajectories(extent);

            this.pointsController.deleteAnnotationsFromMap();
          });
          

        }else {
          this.errorModal.showMesssageModal("Error","Error activating project.");
        }

      },
      (error) => {
        this.errorModal.showMesssageModal("Error","Error activating project.");
      }
    );
  }

  }
